import React, { createContext } from 'react';
import { initModalsData, useModals } from './useModals';
import { Modals } from '../types';
import { initNewWindowHandlers, useHandleNewWindow } from '../hooks/useHandleNewWindow';
export const initialModalAndWindowContextValues = {
  activeModal: Modals.loading,
  setActiveModal: () => {},
  modals: initModalsData,
  newWindowHandlers: initNewWindowHandlers,
  hideModalOverlay: false
};
export const ModalsAndWindowContext = /*#__PURE__*/createContext(initialModalAndWindowContextValues);
export const ModalsAndWindowContextProvider = _ref => {
  let {
    children,
    onInstallationCompleted,
    hideModalOverlay = false
  } = _ref;
  const [activeModal, setActiveModal] = React.useState(Modals.none);
  const modals = useModals({
    setActiveModal,
    onInstallationCompleted
  });
  const newWindowHandlers = useHandleNewWindow();
  return /*#__PURE__*/React.createElement(ModalsAndWindowContext.Provider, {
    value: {
      activeModal,
      setActiveModal,
      modals,
      newWindowHandlers,
      hideModalOverlay
    }
  }, children);
};
export const useModalsAndWindow = () => React.useContext(ModalsAndWindowContext);
//# sourceMappingURL=ModalsAndWindowContext.js.map